import { useParams } from "react-router-dom"
import { ContentHeader, MainContentArea } from "melco-ui";
import { UpdateThreadForm } from "../../components/threads/UpdateThreadForm";
import { ALL_PUBLISHED_STATES } from "../../helper/publishedState";
import { HeaderButtonArea } from "melco-shared-logic";
import { useManageThreadsGetDef } from "../../hooks/threads/useManageThreadsGetDef";
import { ThreadMoreActionButton } from "../../components/threads/ThreadMoreActionsButton";
import { useRolesContext } from "../../hooks/roles/useRolesContext";

export const UpdateThread: React.FC = () => {

    const { threadId } = useParams();
    const { query: { data: thread, refetch }, queryKey } = useManageThreadsGetDef(threadId ?? "", ALL_PUBLISHED_STATES)
    //const thread = undefined
    const { roles } = useRolesContext();


    console.log("70")
    return <> <MainContentArea
        header=
        {
            thread && <ContentHeader
                title={thread.id}
                extra={
                    <>

                        {
                            roles.SYSTEM_THREADS_DELETE && thread?.version === 2 &&
                            <>
                                <HeaderButtonArea />

                                <ThreadMoreActionButton
                                    thread={thread}

                                />

                            </>}

                    </>

                } />

        }
        contentPadding
    >
        {thread && <UpdateThreadForm queryKey={queryKey} refetch={refetch} thread={thread} />}

    </MainContentArea >
    </>





}